import { render, staticRenderFns } from "./VideoPlayerControls.vue?vue&type=template&id=11b070aa&scoped=true&"
import script from "./VideoPlayerControls.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerControls.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerControls.vue?vue&type=style&index=0&id=11b070aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b070aa",
  null
  
)

export default component.exports